<template>
    <div v-if="showBackButton === true" class="site-back-button">
        <a href="#" aria-label="Go Back" title="Go Back" @click.prevent="goBack()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.823 240.823"><path d="M57.633 129.007L165.93 237.268c4.752 4.74 12.451 4.74 17.215 0 4.752-4.74 4.752-12.439 0-17.179l-99.707-99.671 99.695-99.671c4.752-4.74 4.752-12.439 0-17.191-4.752-4.74-12.463-4.74-17.215 0L57.621 111.816c-4.679 4.691-4.679 12.511.012 17.191z"/></svg>
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {
        // isPWA() {
        //     if ('standalone' in window.navigator && window.navigator.standalone) {
        //         return true;
        //     }
        //     else {
        //         return false;
        //     }
        // },
        // notDirectLink() {
        //     if (document.referrer.split('/')[2] !== location.hostname) {
        //         return true;
        //     }
        //     else {
        //         return false;
        //     }
        // },
        showBackButton() {
            let isPWA =
                'standalone' in window.navigator && window.navigator.standalone;
            let direct = document.referrer.split('/')[2] !== location.hostname;

            if (isPWA) {
                // alert('I AM PWA');
                if (direct) {
                    return false;
                } else {
                    return true;
                }
                // return true;
            } else {
                return true;
            }
        },
    },
    methods: {
        goBack() {
            // alert(window.location);
            window.history.back();
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" type="text/scss" scoped>
.homepage .site-back-button {
    display: none;
}

.site-back-button {
    display: none;
    visibility: hidden;
    transition: all 0.2s ease;
    width: 0;

    @media all and (max-width: 480px) {
        display: block;
        visibility: visible;
        width: inherit;
        a {
            padding: 0 5px 0 10px;
        }
    }

    a {
        align-items: center;
        display: flex;
        height: 100%;
        padding: 0 10px;
        margin-right: -10px;
        width: inherit;
    }


    a:focus:not(:focus-visible){
        outline: none;
    }

    a:focus-visible {
        outline: auto;
    }

    svg {
        display: block;
        fill: #333;
        height: 30px;
        width: 25px;
    }
}
</style>
